import {
  LEXUS_ORIGINAL_LBX,
  LEXUS_PREM_LBX,
  LEXUS_PREM_PLUS_DESIGN_LBX,
  LEXUS_PREM_PLUS_LBX,
  LEXUS_TAKUMI_DESIGN_LBX,
  LEXUS_TAKUMI_LBX,
  LEXUS_URBAN_LBX,
} from '@utils/constants'

import { SelectInput } from '../baseInputs'

type Props = {
  grade: string
  helper?: string
  optional?: boolean
}

const Colour = ({ helper, grade, optional, ...rest }: Props) => {
  const name = 'colours'
  const label = 'Colour'

  const colours: { [grade: string]: { label: string; value: string }[] } = {
    Urban: LEXUS_URBAN_LBX,
    Premium: LEXUS_PREM_LBX,
    'Premium Plus': LEXUS_PREM_PLUS_LBX,
    'Premium Plus Design': LEXUS_PREM_PLUS_DESIGN_LBX,
    Takumi: LEXUS_TAKUMI_LBX,
    'Takumi Design': LEXUS_TAKUMI_DESIGN_LBX,
    'Original Edition': LEXUS_ORIGINAL_LBX,
  }

  return (
    <SelectInput
      name={name}
      label={label}
      options={colours[grade]!}
      helper={helper}
      optional={optional}
      {...rest}
    />
  )
}

export default Colour
